import { render, staticRenderFns } from "./Hora.vue?vue&type=template&id=a638bb70&scoped=true&"
import script from "./Hora.vue?vue&type=script&lang=js&"
export * from "./Hora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a638bb70",
  null
  
)

export default component.exports